import React, { useState } from "react";
import { Container, Form, Button, Alert, Card, Row, Col, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/mobili_laranja.png";
import { sendPasswordResetEmail } from "firebase/auth";
import { Modal } from "react-bootstrap";


const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [showResetModal, setShowResetModal] = useState(false);
const [resetEmail, setResetEmail] = useState("");
const [resetMessage, setResetMessage] = useState("");


  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setMessage("✅ Login bem-sucedido!");
      onLogin();
      setTimeout(() => navigate("/"), 1000);
    } catch (error) {
      setMessage("❌ Erro: " + error.message);
    }
  };

  const handlePasswordReset = async () => {
    if (!resetEmail.trim()) {
      setResetMessage("❌ Informe um e-mail válido.");
      return;
    }
  
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetMessage("✅ Link de recuperação enviado com sucesso!");
    } catch (error) {
      setResetMessage("❌ Erro: " + error.message);
    }
  };
  
  return (
    <div className="login-wrapper">
      <Container className="login-container d-flex justify-content-center align-items-center">
        <Card className="login-card p-4">
          
          {/* Container para centralizar o logo */}
          <div className="logo-container">
            <img src={logo} alt="Logo" className="login-logo" />
          </div>

          {/* Título centralizado */}
          <h2 className="text-center mb-4" style={{ color: "#ff7f00" }}>
            Acesso ao Sistema
          </h2>

          {/* Mensagem de erro ou sucesso */}
          {message && <Alert variant={message.includes("❌") ? "danger" : "success"}>{message}</Alert>}

          <Form onSubmit={handleLogin} className="text-start"> {/* Alinha os campos à esquerda */}
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
                placeholder="Digite seu e-mail"
              />
            </Form.Group>

            <Form.Group className="mb-3">
  <Form.Label>Senha</Form.Label>
  <div className="password-container">
    <Form.Control
      type={showPassword ? "text" : "password"}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
      placeholder="Digite sua senha"
      className="password-input"
    />
    <button
      type="button"
      className="password-toggle-btn"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </button>
  </div>
</Form.Group>



            <Button
              variant="primary"
              type="submit"
              className="w-100 mt-3 login-btn"
              style={{ 
                backgroundColor: "#ff7f00", 
                borderColor: "#ff7f00"
              }}
            >
              Entrar
            </Button>
          </Form>

          <Row className="mt-3 text-center">
            <Col>
            <Button
  variant="link"
  className="text-muted p-0"
  onClick={() => {
    setResetEmail(email);
    setResetMessage("");
    setShowResetModal(true);
  }}
>
  Esqueci minha senha
</Button>

            </Col>
          </Row>
        </Card>
      </Container>

      {/* Estilização do componente */}
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .login-wrapper {
          width: 100%;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .login-container {
          width: 100%;
          max-width: 1200px;
          padding: 20px;
        }

        .login-card {
          width: 100%;
          max-width: 400px;
          border-radius: 10px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          background: white;
        }

        .login-btn {
          transition: all 0.3s ease-in-out;
        }

        .login-btn:hover {
          transform: scale(1.05);
        }

        /* Estilo do logo centralizado */
        .logo-container {
          display: flex;
          justify-content: center;
          margin-bottom: 15px;
        }

        .login-logo {
          width: 150px;
          height: auto;
        }

/* Container da senha com botão embutido */
.password-container {
  position: relative;
  display: flex;
  align-items: center;
}

/* Campo de entrada de senha */
.password-input {
  width: 100%;
  padding-right: 40px; /* Garante espaço para o botão */
}

/* Botão de alternar senha dentro do campo */
.password-toggle-btn {
  position: absolute;
  right: 10px; /* Ajuste para alinhar à direita */
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.3s ease-in-out;
}

/* Ajuste do tamanho do ícone */
.password-toggle-btn svg {
  font-size: 1.2rem;
}

/* Efeito hover no botão */
.password-toggle-btn:hover {
  color: #ff7f00; /* Cor de destaque */
}


      `}</style>

<Modal show={showResetModal} onHide={() => setShowResetModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Recuperar Senha</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group className="mb-3">
      <Form.Label>Informe seu e-mail:</Form.Label>
      <Form.Control
        type="email"
        placeholder="exemplo@dominio.com"
        value={resetEmail}
        onChange={(e) => setResetEmail(e.target.value)}
      />
    </Form.Group>
    {resetMessage && (
      <Alert variant={resetMessage.includes("✅") ? "success" : "danger"}>
        {resetMessage}
      </Alert>
    )}
    <div className="text-end">
      <Button variant="primary" onClick={handlePasswordReset}>
        Enviar link
      </Button>
    </div>
  </Modal.Body>
</Modal>

    </div>
  );
};

export default Login;
